import type { PageInfo } from '../../../../shared/types'

export const getReviewsSubVerticalDataLayer = (pageInfo: PageInfo) => pageInfo
